import { handleError } from "../Helpers/ErrorHandler";
import { RegisterRequired } from "../Models/PredefinedModels";
import { UserProfileToken } from "../Models/User";
import { getRemoteValue } from "../Utils/firebase";
import axiosInstance from "./Axios";

export const loginAPI = async (phoneNumber: string, identityNo?: string) => {
  try {
    const data = await axiosInstance.post<UserProfileToken>("auth/send-otp", {
      phoneNumber: phoneNumber,
      identityNo: identityNo,
    });
    return data;
  } catch (error: any) {
    if (error.response) {

      const err = error.response
      if (err?.data?.code == getRemoteValue("NOT_REGISTERED_ERROR_CODE")) {
        return new RegisterRequired(phoneNumber)
      }
    }
    handleError(error);
  }
};

export const verifyOtpAPI = async (otp: string, token: string) => {
  try {
    const data = await axiosInstance.post("auth/validate-otp", {
      otp: otp,
      token: token,
    });
    return data;
  } catch (error: any) {
    handleError(error);
    return error?.response?.data;
  }
};

export const logoutAPI = async () => {
  try {
    const response = await axiosInstance.post("auth/logout");
    return response.data.data;
  } catch (error: any) {
    handleError(error);
    return error?.response?.data;
  }
};
